import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetUserProfileQueryResponse, GetUserProfile400, GetUserProfile500 } from "../types/GetUserProfile";

export const getUserProfileQueryKey = () =>     [{url:`/api/lk/profile`}] as const;
      export function getUserProfileQueryOptions <TData = GetUserProfileQueryResponse, TError = GetUserProfile400 | GetUserProfile500>(options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getUserProfileQueryKey();

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/lk/profile`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Получить профиль пользователя
 * @link /api/lk/profile
 */

export function useGetUserProfile <TData = GetUserProfileQueryResponse, TError = GetUserProfile400 | GetUserProfile500>(options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getUserProfileQueryKey();

  const query = useQuery<TData, TError>({
    ...getUserProfileQueryOptions<TData, TError>(clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
